import { i18n } from 'boot/i18n';
import { Dialog } from 'quasar';
import { bugsnag } from 'boot/bugsnag';

export const showErrorDialog = (e) => {
  // eslint-disable-next-line no-console
  console.log('errorDialog:', e);
  bugsnag.notify(e);

  let title = i18n.global.t('error.dialog.default.title');
  let message = i18n.global.t('error.dialog.default.message', { error: e.message });

  // No connection error
  if (e.message === 'Network Error') {
    title = i18n.global.t('error.dialog.networkError.title');
    message = i18n.global.t('error.dialog.networkError.message');
  }

  // Check for error messages from API
  if (e.response && e.response.data && e.response.data.message) {
    message = i18n.global.t(e.response.data.message);
  }

  Dialog.create({
    title,
    message,
    class: 'bg-dark',
  });
};
